import type { Coord } from "@dailywars/core/engine";
import type { PointerEvent, RefObject } from "react";

import { getTileFromPointer } from "#/game/canvasInput";

function readBoardTileAtPointer({
  canvasRef,
  clientX,
  clientY,
  boardWidth,
  boardHeight,
}: {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  clientX: number;
  clientY: number;
  boardWidth: number;
  boardHeight: number;
}): Coord | null {
  const canvas = canvasRef.current;
  if (!canvas) return null;
  const coord = getTileFromPointer({
    canvas,
    clientX,
    clientY,
    boardWidth,
    boardHeight,
  });
  if (!coord) return null;
  if (coord.x < 0 || coord.y < 0 || coord.x >= boardWidth || coord.y >= boardHeight) return null;
  return coord;
}

export function handleBoardPointerDown({
  event,
  canvasRef,
  boardWidth,
  boardHeight,
  onTileSelect,
  onTileHover,
  onCancelSelection,
  stickInspectOnClick,
}: {
  event: PointerEvent<HTMLCanvasElement>;
  canvasRef: RefObject<HTMLCanvasElement | null>;
  boardWidth: number;
  boardHeight: number;
  onTileSelect: (tile: Coord) => void;
  onTileHover: (tile: Coord | null) => void;
  onCancelSelection?: () => void;
  stickInspectOnClick: boolean;
}) {
  if (stickInspectOnClick) return;
  if (event.button === 2) {
    event.preventDefault();
    onCancelSelection?.();
    return;
  }
  if (event.button !== 0) return;
  const coord = readBoardTileAtPointer({
    canvasRef,
    clientX: event.clientX,
    clientY: event.clientY,
    boardWidth,
    boardHeight,
  });
  if (!coord) return;
  onTileHover(coord);
  onTileSelect(coord);
}

export function handleBoardPointerMove({
  event,
  canvasRef,
  boardWidth,
  boardHeight,
  onTileHover,
}: {
  event: PointerEvent<HTMLCanvasElement>;
  canvasRef: RefObject<HTMLCanvasElement | null>;
  boardWidth: number;
  boardHeight: number;
  onTileHover: (tile: Coord | null) => void;
}) {
  const coord = readBoardTileAtPointer({
    canvasRef,
    clientX: event.clientX,
    clientY: event.clientY,
    boardWidth,
    boardHeight,
  });
  onTileHover(coord);
}
